module.exports = __webpack_public_path__ + "static/media/34.46423276.png";